module.exports = __webpack_public_path__ + "img/chemity_logo.4d7c5cdc.png";